import { Mail, MapPin, Instagram, Package } from "lucide-react";
import { Link } from "react-router-dom";
import PolicyPage from "@/components/PolicyPage";

const CARDS = [
  { icon: Mail, title: "Email", body: <a href="mailto:info@thesyncwear.com" className="text-signal hover:underline break-all" data-testid="contact-email">info@thesyncwear.com</a>, sub: "For orders, sizing, returns and anything else." },
  { icon: MapPin, title: "Location", body: <span data-testid="contact-location">Atlanta, Georgia, USA</span>, sub: "Online-first brand — all orders placed through this site." },
  { icon: Instagram, title: "Instagram", body: <a href="https://www.instagram.com/itssyncwear" target="_blank" rel="noopener noreferrer" className="text-signal hover:underline" data-testid="contact-instagram">@itssyncwear</a>, sub: "Follow the movement." },
  { icon: Package, title: "Order status", body: <Link to="/track-order" className="text-signal hover:underline" data-testid="contact-track-link">Track My Order</Link>, sub: "Live status with your order number and email." },
];

export default function Contact() {
  return (
    <PolicyPage eyebrow="Support" title="Contact SYNC" testid="contact-page"
      intro="Questions about a product, your order, sizing or returns? We're here.">
      <div className="grid sm:grid-cols-2 gap-4 mt-10">
        {CARDS.map(({ icon: Icon, title, body, sub }) => (
          <div key={title} className="border border-border p-6" data-testid={`contact-card-${title.toLowerCase().replace(" ", "-")}`}>
            <Icon size={18} className="text-signal mb-4" />
            <p className="eyebrow mb-2">{title}</p>
            <p className="text-base">{body}</p>
            <p className="text-graphite text-sm mt-2 leading-relaxed">{sub}</p>
          </div>
        ))}
      </div>
      <p className="text-graphite text-sm mt-10 leading-relaxed">
        You can also ask the SYNC assistant — the chat bubble in the corner of every page — for instant answers
        about products, sizing, production and shipping times.
      </p>
    </PolicyPage>
  );
}
